//import 'react-app-polyfill/ie11'; // this must stay on the first line!
import 'react-app-polyfill/stable' // needed for matomotracker typescript. makes app 100k heavier in dev mode
import {createRoot} from 'react-dom/client';
import React from 'react';
import { Provider } from 'react-redux';
import { store } from './reducer';
import './scss/main.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {I18nextProvider} from "react-i18next";
import i18n from './i18n';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <React.StrictMode>
	    <Provider store={store}>
		    <I18nextProvider i18n={i18n}>
			    <App />
		    </I18nextProvider>
	    </Provider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
